import React from 'react';
import {
  AuthProvider,
  DialogProvider,
  FiltersProvider,
  ProductsProvider,
  ValuesProvider
} from 'contexts';
import ProductsImport from "./ProductsImport";

export default () => {
  return (
    <AuthProvider>
      <ProductsProvider>
        <DialogProvider>
          <FiltersProvider>
            <ValuesProvider>
              <ProductsImport/>
            </ValuesProvider>
          </FiltersProvider>
        </DialogProvider>
      </ProductsProvider>
    </AuthProvider>
  );
}
